<template>
  <!-- SharePrice -->
  <div class>
    <div class="w3-container w3-small" id="shareprice">
      <div class="w3-hide-large" style="margin-top:80px"></div>
      <h1 class="w3-xxlarge w3-text-black">
        <b>Share Price.</b>
      </h1>
      <hr style="width:50px;border:5px solid black" class="w3-round" />
      <div>
        <!-- <input type="date" v-model="sharepricedate" class="w3-hide-large" /> -->
        <datepicker
          class="w3-margin w3-left w3-padding-small"
          placeholder="yyyy-MM-dd"
          :typeable="true"
          format="yyyy-MM-dd"
          v-model="sharepricedate"
        ></datepicker>
        <button
          class="w3-left w3-button w3-black w3-margin"
          @click="getSharePrices()"
        >
          <i class="fa fa-search"></i>&nbsp;Search
        </button>
        <ExportToExcel
          @if="shareprices"
          :FieldNames="sharepriceFields"
          :FileName="'SharePrices_' + sharepricedate"
          :InputData="shareprices"
          :MultiHeader="getMultiheader"
          :Merges="['D2:K2', 'D3:K4']"
        />
      </div>
      <br />
      <br />
      <br />
      <div class="w3-clear">
        <div class="w3-responsive">
          <table class="w3-table-all">
            <caption
              @if="shareprices"
              style="text-align:left; font-size:medium"
            >
              Share Prices for
              {{
                sharepricedate | formatDate("YYYY-MM-DD")
              }}
            </caption>
            <thead class="w3-gray">
              <!-- <th class="nowrap">Date</th> -->
              <!-- <th>Company Name</th> -->
              <th class="nowrap">Symbol</th>
              <th class="w3-right-align nowrap">Open</th>
              <th class="w3-right-align nowrap">High</th>
              <th class="w3-right-align nowrap">Low</th>
              <th class="w3-right-align nowrap">Close</th>
              <th class="w3-right-align nowrap">Volume</th>
              <th class="w3-right-align nowrap">Previous Close</th>
              <th class="w3-right-align nowrap">Turnover</th>
              <th class="w3-right-align nowrap">Transaction</th>
            </thead>
            <tbody>
              <tr v-show="sharepriceloading">
                <td colspan="10">Loading...</td>
              </tr>
              <tr v-show="sharepricemessage">
                <td colspan="10">{{ sharepricemessage }}</td>
              </tr>
              <tr
                v-show="!sharepriceloading"
                v-for="shareprice in shareprices.slice(0, -1)"
                v-bind:key="shareprice.stockSymbol"
              >
                <!-- <td class="w3-left-align nowrap">{{ shareprice.tradedate }}</td> -->
                <!-- <td class="w3-left-align w3-hide-small">{{ shareprice.companyName }}</td> -->
                <td class="w3-left-align nowrap">
                  <span :title="shareprice.companyName">
                    {{ shareprice.stockSymbol }}
                  </span>
                </td>
                <td class="w3-right-align nowrap">
                  {{ Number(shareprice.openPrice).toLocaleString() }}
                </td>
                <td class="w3-right-align nowrap">
                  {{ Number(shareprice.highPrice).toLocaleString() }}
                </td>
                <td class="w3-right-align nowrap">
                  {{ Number(shareprice.lowPrice).toLocaleString() }}
                </td>
                <td class="w3-right-align nowrap">
                  {{ Number(shareprice.closePrice).toLocaleString() }}
                </td>
                <td class="w3-right-align nowrap">
                  {{ Number(shareprice.volume).toLocaleString() }}
                </td>
                <td class="w3-right-align nowrap">
                  {{ Number(shareprice.prevClosePrice).toLocaleString() }}
                </td>
                <td class="w3-right-align nowrap">
                  {{ Number(shareprice.turnover).toLocaleString() }}
                </td>
                <td class="w3-right-align nowrap">
                  {{ Number(shareprice.transactionCount).toLocaleString() }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import DataService from "@/services/DataService";
import ExportToExcel from "@/components/ExportToExcel";
export default {
  name: "Shareprice",
  components: {
    Datepicker,
    ExportToExcel,
  },
  data() {
    return {
      shareprices: [],
      sharepricedate: "",
      sharepriceloading: false,
      sharepricemessage: "",
      sharepriceFields: [
        "Date",
        "Company Name",
        "Symbol",
        "Open",
        "High",
        "Low",
        "Close",
        "Volume",
        "Previous Close",
        "Turnover",
        "Transaction",
      ],
    };
  },
  methods: {
    async getSharePrices() {
      this.sharepriceloading = true;
      this.sharepricemessage = "";
      const response = await DataService.getSharePricesFromApi(
        this.sharepricedate
      );
      if (response.data) {
        this.shareprices = response.data;
        if (this.shareprices.length > 0) {
          this.sharepricedate = this.shareprices[0].tradedate
            .toString()
            .replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3");
          this.sharepricemessage = "";
        } else {
          this.sharepricemessage = "No Data Found";
        }
      }
      this.sharepriceloading = false;
    },
  },
  created() {
    this.getSharePrices();
  },
  computed: {
    getMultiheader: function() {
      return [
        ["", "", "", "", "", "", "", "", "", "", ""],
        ["", "", "", "Today's Traded Securities", "", "", "", "", "", "", ""],
        [
          "",
          "",
          "",
          "( " +
            this.$options.filters.formatDate(
              this.sharepricedate,
              "DD-MMM-YYYY"
            ) +
            " )",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
        ],
        ["", "", "", "", "", "", "", "", "", "", ""],
        ["", "", "", "", "", "", "", "", "", "", ""],
      ];
    },
  },
};
</script>

<style></style>
